import React, { HTMLAttributes } from 'react'
import { Space, Message, Tooltip } from '@bedrock/components'
import { Copy } from '@bedrock/icons-react'
import classNames from 'classnames'
import './index.less'
import copy from "copy-to-clipboard";

const TextShow = (props: { text?: string, ableCopy?: boolean, isCopy?: boolean, textShowTitle: string, tipToolTitle?: string } & Omit<HTMLAttributes<HTMLSpanElement>, 'children'>) => {
    const { text, textShowTitle, ableCopy = false, isCopy = false, className, tipToolTitle, ...ret } = props;
    const ableProps = {
        style: ret.style,
        onClick: ret.onClick,
    };
    const handleCopy = (v) => {
        copy(v)
        Message.success({ content: '复制成功' });
    }

    const icon = <Copy
        style={{ color: 'var(--text-color-3)'}}
        onClick={(e) => {
            e.stopPropagation()
            handleCopy(text)
        }}
    />

    let iconWrapper = icon;

    if (tipToolTitle) {
        iconWrapper = <Tooltip title={tipToolTitle}>
            {icon}
        </Tooltip>
    } 

    return (
        <Space size={8}>
            <div title={textShowTitle} className={classNames('sform-text-show', className)} {...ableProps}>
                {[null, undefined, '', NaN, []].includes(text) ? '--' : text}
            </div>
            { (isCopy || ableCopy) && text && iconWrapper }
        </Space>
    );
};

export default TextShow;